import "./MasažasDetail.css";
import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { massages } from "../data";

const backgrounds = [
  "https://res.cloudinary.com/dvuaaubys/image/upload/v1764855154/1_snmtxo.jpg",
  "https://res.cloudinary.com/dvuaaubys/image/upload/v1764855155/2_wx2g3b.jpg",
  "https://res.cloudinary.com/dvuaaubys/image/upload/v1764855156/3_gubuwa.jpg",
  "https://res.cloudinary.com/dvuaaubys/image/upload/v1764855158/4_n6ss1z.jpg",
  "https://res.cloudinary.com/dvuaaubys/image/upload/v1764855160/5_nhntwk.jpg",
];

function MasažasDetail() {
  const { slug } = useParams();
  const massage = massages.find((m) => m.slug === slug);
  const currentIndex = massages.findIndex((m) => m.slug === slug);
  const prevMassage = currentIndex > 0 ? massages[currentIndex - 1] : null;
  const nextMassage =
    currentIndex >= 0 && currentIndex < massages.length - 1
      ? massages[currentIndex + 1]
      : null;

  // Scroll to top when component mounts or slug changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  // Pick random background based on slug for consistency
  const bgIndex =
    slug.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
    backgrounds.length;
  const bgImage = backgrounds[bgIndex];

  if (!massage) {
    return (
      <div className="masazas-detail-section" style={{ paddingTop: "10rem" }}>
        <div className="masazas-apie-container">
          <h2>Masažas nerastas</h2>
          <Link to="/" className="back-link">
            Grįžti į pradžią
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div
      className="masazas-detail-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="masazas-apie-container">
        <div className="masazas-title-section">
          <h2 className="masazas-apie-title">{massage.title}</h2>
        </div>
        <div className="masazas-content-wrapper">
          <div className="masazas-text-box-detail">
            <div className="masazas-info">
              <h2 className="duration">
                <strong>Trukmė:</strong> {massage.duration}
              </h2>
              <h2 className="price">
                <strong>Kaina:</strong> {massage.price}
              </h2>
            </div>
            <p className="masazas-description">{massage.description}</p>
            <p className="masazas-result">
              <strong>Rezultatas:</strong> {massage.result}
            </p>
            <p className="masazas-about">{massage.about}</p>
          </div>
          <div className="masazas-nav">
            {prevMassage ? (
              <Link
                className="nav-link prev"
                to={`/masazas/${prevMassage.slug}`}
              >
                ← {prevMassage.title}
              </Link>
            ) : (
              <span />
            )}
            {nextMassage && (
              <Link
                className="nav-link next"
                to={`/masazas/${nextMassage.slug}`}
              >
                {nextMassage.title} →
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MasažasDetail;
